import { useLang } from "@/i18n/LanguageContext";
import { useSectionVideo } from "./useSectionVideo";

export const SectionVideo = ({
  src, sources, poster, className = "", aspect = "aspect-video", fill = false,
  dim = 0, overlayLabels = [], rounded = "rounded-2xl", testId,
}) => {
  const { t } = useLang();
  const candidates = sources || [{ src, type: "video/mp4" }];
  const player = useSectionVideo(candidates.length);
  const error = player.status === "error" && (
    <p role="status" className="relative z-[4] bg-[#050a15]/95 px-4 py-3 text-sm text-white" data-testid={`${testId}-error`}>
      {t.sectionVideo.error}
    </p>
  );
  const media = (
    <>
      {poster && <img src={poster} alt="" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" data-testid={`${testId}-poster`} />}
      {player.shouldLoad && (
        <video
          key={player.sourceIndex}
          ref={player.videoRef}
          id={`${testId}-media`}
          src={candidates[player.sourceIndex].src}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-300 motion-reduce:transition-none ${player.hasFrame ? "opacity-100" : "opacity-0"}`}
          muted loop playsInline autoPlay={player.shouldPlay} controls={false} preload="metadata" poster={poster}
          aria-hidden="true"
          data-testid={`${testId}-el`}
          {...player.events}
        />
      )}
      {dim > 0 && <div className="absolute inset-0 pointer-events-none" style={{ background: `rgba(2,4,10,${dim})`, zIndex: 2 }} />}
      <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: "inset 0 0 70px 10px rgba(2,4,10,0.6)", zIndex: 2 }} />
      <span className={`absolute inset-0 ${rounded} pointer-events-none`} style={{ boxShadow: "inset 0 0 0 1px rgba(59,130,246,0.4), 0 0 44px -10px rgba(59,130,246,0.45)", zIndex: 3 }} />
      <span className="scan-line pointer-events-none" style={{ zIndex: 3 }} />
      {overlayLabels.length > 0 && (
        <div className="absolute inset-x-0 bottom-0 p-3 sm:p-4 pt-8 flex flex-wrap gap-1 sm:gap-2 pointer-events-none" style={{ zIndex: 4, background: "linear-gradient(to top, rgba(2,4,10,0.85), transparent)" }}>
          {overlayLabels.map((text, index) => (
            <span key={text} data-testid={`${testId}-label-${index}`} className="inline-flex max-w-full items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-[var(--blue-bright)] border border-[var(--line-strong)] bg-[rgba(2,4,10,0.5)] rounded-full px-2.5 py-1">
              <span className="h-1 w-1 shrink-0 rounded-full bg-[var(--green)]" /> {text}
            </span>
          ))}
        </div>
      )}
    </>
  );

  if (fill) {
    return (
      <>
        <div ref={player.frameRef} className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-testid={testId} data-playback-state={player.status}>
          {media}
        </div>
        {error}
      </>
    );
  }
  return (
    <div className={`relative ${rounded} overflow-hidden video-frame ${className}`} data-testid={testId} data-playback-state={player.status}>
      {error}
      <div ref={player.frameRef} className={`relative w-full ${aspect}`}>
        {media}
      </div>
    </div>
  );
};